import React from 'react';
import {CardElement} from 'react-stripe-elements';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import {COLORS} from '../../../common/constants';

const Label = styled.label`
  padding: 15px;
`;

const CardContainer = styled.div`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 10px;
`;


const style = {
  base: {
    color: COLORS.BLACK,
    fontFamily: '"Segoe UI Bold", sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: COLORS.GRAY,
    },
  },
  invalid: {
    color: COLORS.DARK_PINK,
    iconColor: COLORS.DARK_PINK,
  },
};

const CardSection = ({t}) => {
  return (
    <Label>
      {t('cardDetails')}
      <CardContainer>
        <CardElement style={style}/>
      </CardContainer>
    </Label>
  );
};

export default compose(
  withTranslation('stripe'),
)(CardSection);
